export default "__VITE_ASSET__2aTSGIMb__"